"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusOverview = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Theme_1 = require("@amzn/atoz-web/Theme");
const TaskItem_1 = require("../../../components/TaskItem");
const useStatusOverview_1 = require("../../../components/PunchCorrectionStatus/StatusOverview/hooks/useStatusOverview");
const StatusOverview = ({ type, status, reason, dateTime, initialDateTime, militaryTime, isInTaskList = false, showStatusDetails }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { ariaLabel, statusKey, chipBgColor, title, timeString, dateString, initialTimeString, initialDateString } = (0, useStatusOverview_1.useStatusOverview)({
        dateTime,
        initialDateTime,
        militaryTime,
        reason,
        type,
        status
    });
    const renderChipIcon = () => chipBgColor === 'red' && (react_1.default.createElement(Icons_1.IconAlertCircleFill, { dataTestId: "FailedChipIcon", size: Icons_1.IconSize.ExtraSmall, color: "red70" }));
    return (react_1.default.createElement(TaskItem_1.TaskItem, { ariaLabel: ariaLabel, chipText: t(statusKey), chipBgColor: chipBgColor, title: title, subTitle: `${timeString} | ${dateString}`, note: initialTimeString && initialDateString
            ? `${t('time_and_attendance_StatusOverview_Note_InitialPunch')}: ${initialTimeString} | ${initialDateString}`
            : '', renderChipIcon: isInTaskList ? renderChipIcon : undefined, renderIconButton: (isInTaskList || showStatusDetails) &&
            (() => (react_1.default.createElement(IconButton, { isInTaskList: isInTaskList, "aria-label": isInTaskList
                    ? t('time_and_attendance_TaskList_ListItemButton_AccessibilityLabel_View')
                    : t('time_and_attendance_StatusOverview_DetailsButton_ariaLabel'), onClick: showStatusDetails }, isInTaskList ? (react_1.default.createElement(Icons_1.IconChevronRight, { dataTestId: "viewPunchStatusDetails", color: "primary70", title: t('time_and_attendance_StatusOverview_DetailsButton_ariaLabel') })) : (react_1.default.createElement(Icons_1.IconQuestionCircle, { size: Icons_1.IconSize.ExtraSmall, color: "primary70", dataTestId: "QuestionButton", title: t('time_and_attendance_StatusOverview_DetailsButton_ariaLabel') }))))) }));
};
exports.StatusOverview = StatusOverview;
const IconButton = (0, Theme_1.styledWithTheme)('button')(({ theme, isInTaskList }) => `
  background-color: transparent;
  border: 2px solid transparent;
  border-radius: 50%;
  padding: 6px;

  &:hover {
    cursor: pointer;
    border-color: ${isInTaskList ? theme.selectors.color('primary70') : 'transparent'};
  }

  &:focus-visible {
    border-color: ${theme.selectors.color('primary70')};
  }
  `);
